module.exports = __webpack_public_path__ + "img/default-project.a399a544.png";